module.exports = __webpack_public_path__ + "static/img/bg1.c608dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/bg1.png
// module id = rY8F
// module chunks = 1